import { useDispatch } from "react-redux";
import ModalOptional from "../UI/ModalOptional";
import { layoutActions } from "../../store/layout-slice";
import { useCallback, useEffect, useState } from "react";
import GenericGoogleSheetService from "../../Helper/GoogleSheetService";
import { useSelector } from "react-redux";
import { ReplaceTextToSpecialChar } from "../../Helper/WidgetDataCommon";
import HtmlParser from "../UI/HtmlContentParser";
import GSheetForm from "./GSheetForm";
import Loader from "../UI/Loader";


const GoogleSheetSettings = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const sessionId = useSelector((state) => state.login.sessionId);
    const isEditGsheet = useSelector((state) => state.layout.IsEditGSheet);
    const [gConnectionList, setGConnectionList] = useState([]);
    const [existingConnectionName, setExistingConnectionName] = useState("");


    useEffect(() => {

        const fetchGoogleSheetConnections = async () => {
            try {
                setIsLoading(true);
                await GenericGoogleSheetService.getGoogleConnectionList(sessionId).then((res) => {
                    setGConnectionList(res);
                    setIsLoading(false);

                }).catch((err) => {
                    console.error(err);
                    setIsLoading(false);
                });
            } catch (error) {
                console.error("Error fetching Google Sheet connections:", error);
                setIsLoading(false);
            }
        };

        if (isEditGsheet) {
            //fetch existing connections for edit/delete
            fetchGoogleSheetConnections();
        }

    }, []);

    const onCloseHandler = useCallback(() => {
        dispatch(layoutActions.setGsheetPopup(false));
    }, [dispatch]);

    const editGoogleSheetDdlChange = (event) => {
        const selectedSheet = event.target.value;
        setExistingConnectionName(selectedSheet);
    };

    return (
        <ModalOptional title={isEditGsheet ? "Edit Google Sheet Connection" : "Create Google Sheet Connection"} width={{ width: "450px" }} onClose={onCloseHandler}>
            {isEditGsheet && existingConnectionName === "" && (
                <>
                    {!isLoading && (<form id="existingForm" className="settings">
                        <div>
                            <div style={{ paddingBottom: "40px", paddingTop: "10px" }}>
                                <p>Select Google Sheet Connection For Edit/ Delete</p>
                                <select name="existingSheets" onChange={editGoogleSheetDdlChange}>
                                    <option value="">Select Google Sheet Connection</option>
                                    {gConnectionList.map((connection, index) => {
                                        return (
                                            <option key={index} value={ReplaceTextToSpecialChar(connection)}>
                                                <HtmlParser htmlString={ReplaceTextToSpecialChar(connection).replace(/ /g, "&nbsp;")} />
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </form>)}
                    {isLoading && (<div style={{ paddingTop: "18px", paddingBottom: "18px" }}><Loader styles={{ height: "80px" }} /></div>)}
                </>
            )}

            {!isEditGsheet || (isEditGsheet && existingConnectionName !== "") ? (
                <GSheetForm onCloseHandler={onCloseHandler}
                    isEditGsheet={isEditGsheet} existingConnectionName={existingConnectionName} />
            ) : null}

        </ModalOptional >
    );
};

export default GoogleSheetSettings;
